import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/assets/categories/jockey.jpg")